import React from 'react';

import cs from 'classnames';

import {useSetAcceptanceStatus} from 'app/acceptance/api';
import StateButton from 'app/general/widgets/StateButton';
import {gt} from 'app/utils/i18n';

import type {
  AcceptanceStatusSerializedType,
  BaseDocumentContentType,
} from 'sweet-types';

type Props = {
  acceptancestatus: AcceptanceStatusSerializedType;
  contentType: BaseDocumentContentType;
  documentId: number;
  className?: string;
};

export const ConfirmButton = ({
  acceptancestatus,
  contentType,
  documentId,
  className,
}: Props) => {
  const [setAcceptanceStatus] = useSetAcceptanceStatus();

  return (
    <StateButton
      className={cs(className || 'btn btn-primary', {
        active: acceptancestatus.status,
      })}
      disabled={acceptancestatus.status === true || undefined}
      busyText={
        <span className="d-none d-sm-inline">{gt('Confirming...')}</span>
      }
      onClick={() =>
        setAcceptanceStatus({
          id: acceptancestatus.id,
          document_id: documentId,
          content_type: contentType,
          status: true,
        }).unwrap()
      }
    >
      <i className="fal fa-thumbs-up mr-2" />
      {acceptancestatus.status ? gt('You confirmed') : gt('Confirm')}
    </StateButton>
  );
};
